import React from "react";
import DailyChart from "./DailyChart";
import MonthlyChart from "./MonthlyChart";
import YearlyChart from "./YearlyChart";
import IssueComponentChart from "./IssueComponentChart";
import HighestTicketPropertyChart from "./HighestTicketPropertyChart";
import { Card } from "antd";
import "./style.css";

function DailyManagmentChart() {
    return (
        <div className="dashboard-count-card">
            <h1 style={{ marginRight: "auto" }}>Success Percentage</h1>
            <div className="flex flex-wrap flex-gap-10">
                <div
                    className="flex flex-column flex-gap-10"
                    style={{ width: "35%" }}
                >
                    <MonthlyChart />
                    <YearlyChart />
                </div>
                <DailyChart />
                <IssueComponentChart />
                <HighestTicketPropertyChart />
            </div>
        </div>
    );
}

export default DailyManagmentChart;
